import { useEffect, useRef, useState } from "react";

let apiPromise;
const loadAPI = () => {
  apiPromise =
    apiPromise ||
    new Promise((resolve) => {
      if (window.YT?.Player) return resolve(window.YT);
      const prev = window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady = () => {
        prev?.();
        resolve(window.YT);
      };
      const s = document.createElement("script");
      s.src = "https://www.youtube.com/iframe_api";
      document.head.appendChild(s);
    });
  return apiPromise;
};

const hideCaptions = (p) => {
  try {
    p.setOption?.("captions", "track", {});
    p.unloadModule?.("captions");
    p.unloadModule?.("cc");
  } catch {
    /* captions module not present */
  }
};

const Player = ({ id, playing, onError, testid, vertical }) => {
  const host = useRef(null);
  const player = useRef(null);
  const ready = useRef(false);
  const playingRef = useRef(playing);
  playingRef.current = playing;

  useEffect(() => {
    let alive = true;
    loadAPI().then((YT) => {
      if (!alive || !host.current) return;
      player.current = new YT.Player(host.current, {
        videoId: id,
        host: "https://www.youtube-nocookie.com",
        playerVars: { autoplay: 1, mute: 1, loop: 1, playlist: id, controls: 0, playsinline: 1, rel: 0, iv_load_policy: 3, disablekb: 1, cc_load_policy: 0 },
        events: {
          onReady: (e) => {
            ready.current = true;
            e.target.mute();
            hideCaptions(e.target);
            if (playingRef.current) e.target.playVideo();
            else e.target.pauseVideo();
          },
          onStateChange: (e) => {
            if (e.data === 1) hideCaptions(e.target);
          },
          onError: () => onError?.(),
        },
      });
    });
    return () => {
      alive = false;
      player.current?.destroy?.();
    };
  }, [id, onError]);

  useEffect(() => {
    if (!ready.current) return;
    if (playing) player.current?.playVideo();
    else player.current?.pauseVideo();
  }, [playing]);

  return (
    <div
      data-testid={testid}
      className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 [&_iframe]:h-full [&_iframe]:w-full [&_iframe]:border-0"
      style={
        vertical
          ? { width: "max(100cqw, calc(100cqh * 9 / 16))", height: "max(100cqh, calc(100cqw * 16 / 9))" }
          : { width: "max(100cqw, calc(100cqh * 16 / 9))", height: "max(100cqh, calc(100cqw * 9 / 16))" }
      }
    >
      <div ref={host} />
    </div>
  );
};

export const YouTubeLayer = ({ id, playing, onError, className = "", testid, vertical = false }) => {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    if (playing) setMounted(true);
  }, [playing]);
  if (!mounted) return null;
  return (
    <div className={`pointer-events-none absolute inset-0 overflow-hidden [container-type:size] ${className}`}>
      <Player id={id} playing={playing} onError={onError} testid={testid} vertical={vertical} />
    </div>
  );
};
